import CommonTitleBar from "components/common/CommonTitleBar";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import WorkshopCard from "./WorkshopCard";
import NoDataFound from "components/common/NoDataFound";
import { useDispatch, useSelector } from "react-redux";
import { getAllWorkspaces } from "store/actions/workspaceSlice";
import Spinners from "components/common/Spinners";
import Paginations from "components/common/Paginations";
import { ShimmerContentBlock } from "react-shimmer-effects";
import WorkshopShimmer from "components/ShimmerEffects/WorkshopShimmer";
import { workShopStatusTypes } from "components/constants/StatusKeys";
import FiltersWithoutSearch from "components/common/FiltersWithoutSearch";
import { setPageTitle } from "components/common/Utils";
const Workshop = () => {
  const { t } = useTranslation();
  setPageTitle("Workshop", t);


  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const pageNumber = Number(new URLSearchParams(search).get("page")) || 1;
  const [keyword, setKeyword] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({
    type: -1,
    spaceType: null,
    branches: [],
  });
  const {
    isLoading,
    loading,
    workspaces: workshops,
    drafts,
    unavailable,
    archived,
    perPage,
    totalCount,
    totalPages,
    currentPage,
  } = useSelector((state) => state.Workspace);

  useEffect(() => {
    getAllData();
  }, [selectedFilters]);

  const getAllData = (page, actionType) => {
    let status = actionType === "RESET" ? -1 : selectedFilters?.status ?? -1;
    const payload = {
      spaceTypeInt: 3, // Space Type Int [1-workSpace , 2-meetingRoom , 3-workShop]
      perPage: perPage,
      pageNo: page || pageNumber,
      status: status || -1,
      orderBy: -1,
      keyword: "",
      dateRange: {},
    };
    dispatch(getAllWorkspaces(payload));
    navigate(`/bookings/workshops?page=${page || pageNumber}`);
  };

  const filters = [
    {
      key: "status",
      placeholder: "Workshop Status",
      options: workShopStatusTypes,
      type: "singleSelect",
    },
  ];

  const handleReset = () => {
    setKeyword("");
    setSelectedFilters({ status: null });
    getAllData(pageNumber, "RESET");
  };

  return (
    <React.Fragment>
      <div className="page-content common_page workshop_page">
        <Container fluid>
          <CommonTitleBar
            title={t("Workshops")}
            isCreateBtn={true}
            createBtnText={t("Add New")}
            onCreateBtnClick={() => navigate("/bookings/workshops/add-new")}
          />
          <div className="common_wrapper">
            <div className="">
              <FiltersWithoutSearch
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
                filters={filters}
                onSearch={getAllData}
                onReset={handleReset}
                className="filter_2"
                isDateRange={false}
                showSearchButton={false}
              />
            </div>

            <div className="workshop_row">
              {loading ? (
                <WorkshopShimmer />
              ) : selectedFilters.status === 4 ? (
                unavailable?.length === 0 ? (
                  <NoDataFound text={t("No unavailable workshops")} />
                ) : (
                  unavailable?.map((item) => (
                    <WorkshopCard
                      key={item?._id}
                      item={item}
                      isLoading={isLoading}
                    />
                  ))
                )
              ) : selectedFilters.status === 5 ? (
                archived?.length === 0 ? (
                  <NoDataFound text={t("No archived workshops")} />
                ) : (
                  archived?.map((item) => (
                    <WorkshopCard
                      key={item?._id}
                      item={item}
                      isLoading={isLoading}
                    />
                  ))
                )
              ) : workshops?.length === 0 ? (
                <NoDataFound text={t("No workshops found")} />
              ) : (
                workshops?.map((item) => (
                  <WorkshopCard
                    key={item?._id}
                    item={item}
                    isLoading={isLoading}
                  />
                ))
              )}
            </div>
          </div>

          {selectedFilters.status !== 4 && selectedFilters.status !== 5 && (
            <>
              <h2 className="main_title">
                {t("Draft")}
              </h2>
              <div className="common_wrapper">
                {loading ? (
                  <WorkshopShimmer />
                ) : drafts?.length === 0 ? (
                  <NoDataFound text={t("No drafts saved yet")} />
                ) : (
                  <div className="workshop_row">
                    {drafts?.map((item) => (
                      <WorkshopCard
                        key={item?.id}
                        item={item}
                        className="draft"
                        isLoading={isLoading}
                      />
                    ))}
                  </div>
                )}
              </div>
            </>
          )}

          {!loading && (
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page) => {
                getAllData(page);
              }}
              totalCount={totalCount}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Workshop;
